/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";

const initialDataState = { sort: [{ field: "code", dir: "asc" }] };

function CDMReconciliationsGrid({ data }: { data: any[] }) {
  const [dataState, setDataState] = useState<any>(initialDataState);

  return (
    <Grid
      data={process(
        data.map((req) => ({
          ...req,
        })),
        dataState
      )}
      {...dataState}
      onDataStateChange={(e: any) => {
        setDataState(e.dataState);
      }}
    >
      <Column
        field="serialNo"
        title="Sr. #"
        width="80px"
        className="grid-cell-font-size text-center"
      />
      <Column
        field="customer"
        title="Customer"
        width="120px"
        className="grid-cell-font-size"
      />
      <Column
        field="locationId"
        title="Location Id"
        width="100px"
        className="grid-cell-font-size"
      />
      <Column
        field="locationName"
        title="Location Name"
        width="200px"
        className="grid-cell-font-size"
      />
      <Column
        field="machineType"
        title="Machine Type"
        width="150px"
        className="grid-cell-font-size"
      />
      <Column
        field="maker"
        title="Maker"
        width="80px"
        className="grid-cell-font-size"
      />
      <Column
        field="serviceDate"
        title="Service Date"
        width="150px"
        className="grid-cell-font-size"
      />
      <Column
        field="processingDate"
        title="Processing Date"
        width="150px"
        className="grid-cell-font-size"
      />
      <Column
        field="teamLeader"
        title="Team Leader"
        width="120px"
        className="grid-cell-font-size"
      />
      <Column
        field="denomination"
        title="Denomination"
        width="120px"
        className="grid-cell-font-size"
      />
      <Column
        field="count"
        title="Notes"
        width="80px"
        className="grid-cell-font-size"
      />
      <Column
        field="amount"
        title="Amount"
        width="100px"
        className="grid-cell-font-size"
      />
      <Column
        field="type"
        title="Type"
        width="80px"
        className="grid-cell-font-size"
      />
      <Column
        field="nature"
        title="Nature"
        width="80px"
        className="grid-cell-font-size"
      />
      <Column field="remarks" title="Remarks" className="grid-cell-font-size" />
    </Grid>
  );
}

export default React.memo(CDMReconciliationsGrid);
